import { render } from "./zyjReviewList.vue?vue&type=template&id=c5b5276c&scoped=true"
import script from "./zyjReviewList.vue?vue&type=script&lang=js"
export * from "./zyjReviewList.vue?vue&type=script&lang=js"

import "./zyjReviewList.vue?vue&type=style&index=0&id=c5b5276c&scoped=true&lang=scss"

import exportComponent from "H:\\Environment_蓝宇\\Src\\GZXY\\GZEUA\\GZ_CQ_V2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5b5276c"]])

export default __exports__